/**
 * !!! AUTOGENERATED, DO NOT MODIFY !!!
 *
 * This file is generated by dashboard/script/remote_lookup/generate_remote_lookup_schemas.rb
 * Because the generation script depends on rails, generation is run manually and the file is checked in.
 * Please do not edit manually.
 *
 * To regenerate, run:
 *   yarn remote-lookup:update-generated-schemas
 *
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../common";

// Our zod-to-typescript generation tooling demands an export that matches the module name.
export const customAttributeRemoteLookupSchema = z.any();

export const customAttributeRemoteLookupIdSchema = z.string();

export const customAttributeRemoteLookupItemSchema = z.object({
  indexed_name: z.string(),
  name: z.string(),
  description: z.string(),
  type: z.enum(["Nil", "String", "Number", "Boolean", "Time", "Array", "Object", "Object Array"]),
  is_blocklisted: z.boolean(),
  is_deleted: z.boolean(),
  status: z.enum(["active", "deleting", "deleted", "blocklisting", "blocklisted"]),
  internal_id: common.objectId,
});

export const customAttributeRemoteLookupFiltersSchema = z.object({
  attribute_types: z
    .array(z.enum(["Nil", "String", "Number", "Boolean", "Time", "Array", "Object", "Object Array"]))
    .nullable()
    .nullable()
    .optional(),
});

export const customAttributeRemoteLookupValidators = {
  id: customAttributeRemoteLookupIdSchema,
  item: customAttributeRemoteLookupItemSchema,
  filters: customAttributeRemoteLookupFiltersSchema,
};

/* rails_test_output_hash: a788e031ad7c753523e8c32c85c187d3 */
